import React, { useState, useEffect } from "react";

import Select from "../../select/select_v2";
import SignatureTypeCards from "../../signatureTypeCards";
import Button from "../../button/button_v2";
import api from "../../../services/api";
import { Container } from "react-grid-system";
import Input from "../../input/input_v2";
import { FormContainer } from "./styles";
import { store } from "react-notifications-component";
import ModalUpload from '../../modal/modalUploadCertificado';
import ModalGeneric from '../../modal/modalGeneric';
import InputSign from '../../inputSign';
import CardUserCfta from "../../card-user-cfta";
import { ModalBody } from './styles';
import { ModalTitle } from '../../modal/styles';
import { Auxiliar, BodyG, BodyGSpan, H5 } from '../../../styles/stylesTypography';
import { theme } from '../../../styles/theme';
import ButtonV2 from '../../../components/button/button_v2';
import iconQuestionBlue from '../../../assets/icons/icon-question-blue.png';

import * as S from "./styles"
import ModalImage from '../../../assets/modalRecursoClientes.svg';
import Tooltip from "../../tooltip";
import { isTotvs } from "../../../services/globalFunctions";
import identifyErrorMenssage from "../../../services/identifyErrorMenssage";
export const USER = "@userinfo";

const SIGN_LABELS = { M: 'Manual', D: 'Digital', E: 'Eletrônica' };

const AddCreas = ({ ...props }) => {

    const { nome, cpf, email, sign, agronomoId, enviar_receita, whatsapp } = props;

    const [numeroCrea, setNumeroCrea] = useState('');
    const [erroNumeroCrea, setErroNumeroCrea] = useState(false);
    const [agronomoNome, setAgronomoNome] = useState('')
    const [erroAgronomo, setErroAgronomo] = useState(false)
    const [tipoId, setTipoId] = useState('');
    const [erroTipo, setErroTipo] = useState(false);

    const tipos = [{
        value: 'crea', label: 'CREA'
    }, {
        value: 'visto', label: 'VISTO'
    }, {
        value: 'cfta', label: 'CFTA'
    }];

    const [receitaInicial, setReceitaInicial] = useState('');
    const [erroReceitaInicial, setErroReceitaInicial] = useState(false);
    const [receitasEmitidas, setReceitasEmitidas] = useState('');
    const [status] = useState({ value: 1, label: 'Ativo' });
    const [homologAutomatico, setHomologAutomatico] = useState('');
    const estados = [
        { value: "NACIONAL", label: "Nacional" },
        { value: "SP", label: "São Paulo" },
        { value: "RJ", label: "Rio de Janeiro" },
        { value: "SC", label: "Santa Catarina" },
        { value: "AC", label: "Acre" },
        { value: "AL", label: "Alagoas" },
        { value: "AP", label: "Amapa" },
        { value: "AM", label: "Amazonas" },
        { value: "BA", label: "Bahia" },
        { value: "CE", label: "Ceará" },
        { value: "DF", label: "Distrito Federal" },
        { value: "ES", label: "Espirito Santo" },
        { value: "GO", label: "Goiás" },
        { value: "MA", label: "Maranhão" },
        { value: "MT", label: "Mato Grosso" },
        { value: "MS", label: "Mato Grosso do Sul" },
        { value: "MG", label: "Minas Gerais" },
        { value: "PA", label: "Pará" },
        { value: "PB", label: "Paraíba" },
        { value: "PR", label: "Paraná" },
        { value: "PE", label: "Pernambuco" },
        { value: "PI", label: "Piaui" },
        { value: "RN", label: "Rio Grande do Norte" },
        { value: "RS", label: "Rio Grande do Sul" },
        { value: "RO", label: "Rondônia" },
        { value: "RR", label: "Roraima" },
        { value: "SE", label: "Sergipe" },
        { value: "TO", label: "Tocantins" },
        { value: "", label: "" }
    ];
    const estados1 = [
        { value: "SP", label: "São Paulo" },
        { value: "RJ", label: "Rio de Janeiro" },
        { value: "SC", label: "Santa Catarina" },
        { value: "AC", label: "Acre" },
        { value: "AL", label: "Alagoas" },
        { value: "AP", label: "Amapa" },
        { value: "AM", label: "Amazonas" },
        { value: "BA", label: "Bahia" },
        { value: "CE", label: "Ceará" },
        { value: "DF", label: "Distrito Federal" },
        { value: "ES", label: "Espirito Santo" },
        { value: "GO", label: "Goiás" },
        { value: "MA", label: "Maranhão" },
        { value: "MT", label: "Mato Grosso" },
        { value: "MS", label: "Mato Grosso do Sul" },
        { value: "MG", label: "Minas Gerais" },
        { value: "PA", label: "Pará" },
        { value: "PB", label: "Paraíba" },
        { value: "PR", label: "Paraná" },
        { value: "PE", label: "Pernambuco" },
        { value: "PI", label: "Piaui" },
        { value: "RN", label: "Rio Grande do Norte" },
        { value: "RS", label: "Rio Grande do Sul" },
        { value: "RO", label: "Rondônia" },
        { value: "RR", label: "Roraima" },
        { value: "SE", label: "Sergipe" },
        { value: "TO", label: "Tocantins" },
        { value: "", label: "" }
    ];
    const [estadoId, setEstadoId] = useState("");
    const [erroEstado, setErroEstado] = useState(false);
    const [filiais, setFiliais] = useState([]);
    const [filial, setFilial] = useState('');
    const [erroFilial, setErroFilial] = useState(false);
    const [usuario, setUsuario] = useState('');
    const [senha, setSenha] = useState('');

    const [usuarioSc, setUsuarioSc] = useState('');
    const [senhaSc, setSenhaSc] = useState('');
    const [usuarioEs, setUsuarioEs] = useState('');
    const [senhaEs, setSenhaEs] = useState('');

    const [typePassword, setTypePassword] = useState('password');
    const [tiposAssinatura, setTiposAssinatura] = useState([
        { value: 'M', label: 'Manual' },
        { value: 'D', label: 'Digital' },
        { value: 'E', label: 'Eletrônica' }
    ]);
    const [assinaturaId, setAssinaturaId] = useState('');
    const [showModalUpload, setShowModalUpload] = useState(false);
    const [showSignatureModal, setShowSignatureModal] = useState(false);
    const [hasDigitalCredentialLocal, setHasDigitalCredentialLocal] = useState(props.certificado === true);
    const [hasElectronicCredentialLocal, setHasElectronicCredentialLocal] = useState(typeof sign === 'string' && sign.length > 0);
    const [electronicSignatureOverride, setElectronicSignatureOverride] = useState('');
    const [loading, setLoading] = useState(false);
    const [contractSoftId, setContractSoftId] = useState('');
    const [isCrea, setIsCrea] = useState(false);
    const [agronomo, setAgronomo] = useState([]);
    const [blockSign, setBlockSign] = useState(false);
    const [showModalBlockSign, setShowModalBlockSign] = useState(false);

    const [erroUsuario, setErroUsuario] = useState(false);
    const [erroSenha, setErroSenha] = useState(false);
    const [isLoadingSignRules, setIsLoadingSignRules] = useState(false);

    const selectAssinatura = (ass) => {
        if (blockSign && (ass.value === 'D' || ass.value === 'E')) {
            setShowModalBlockSign(true);
        }
        setAssinaturaId(ass);
    }

    const getAgronomos = async () => {
        try {
            const response = await api.get(`/agronomos/${agronomoId}`);
            const agronomo = response.data.data;

            setAgronomo(agronomo);
            setAgronomoNome(agronomo.nome);
            if (agronomo.creas.length > 0) {
                agronomo.creas.map(c => {
                    if (c.status == 1) {
                        setIsCrea(true);
                    }
                })
            }
        } catch (error) {
        }
    };

    const getFiliais = async () => {

        const currentPath = window.location.pathname;
        const idPath = currentPath.split('/').pop();
        if (idPath !== 'add') {
            const response = await api.get(`/agronomos/${idPath}`);
            const id = response.data.data.filial.parent_id

            try {
                // const response = await api.get(`/filiais/${id}`);
                const response = await api.get(`/filiais`);
                const filiais = response.data.data;

                if (filiais.length) {
                    const formatFiliais = filiais.map(f => {
                        let format = {
                            value: f.id,
                            label: f.nome_fantasia
                        };
                        return format;
                    });

                    if (filiais && filiais.length > 0) {
                        setFiliais(formatFiliais);
                    } else {
                        setFiliais(formatFiliais);
                    }
                } else {
                    const formatFiliais = [{ value: filiais.id, label: filiais.nome_fantasia }];
                    setFiliais(formatFiliais);

                }
            } catch (e) {

            }
        }
    };

    const validateNumeroCrea = numeroCrea => {
        setNumeroCrea(numeroCrea);
    }
    const validateReceitaInicial = receitaInicial => {
        let inputWithErrors = document.querySelectorAll(".error");
        for (let input of inputWithErrors) {
            input.classList.remove("error");
        }
        setReceitaInicial(receitaInicial);
    }
    const validateReceitaZero = valor => {
        if (valor == 0) {
            setReceitaInicial('');

            const select = document.getElementById("receita_inicial");
            select.classList.add("error");

            store.addNotification({
                title: "Erro!",
                message: `O campo receita inicial deve ser maior que zero`,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    }

    const handlePost = async e => {
        if (agronomoId) {
            const payload = {
                estado: estadoId.value || estadoId,
                homologar_automatico: (
                    estadoId.value === 'MT' || estadoId.value === 'SC' || estadoId.value === 'ES' || estadoId.value === 'GO' || estadoId.value === 'DF' || estadoId === 'NACIONAL'
                ) && contractSoftId !== 6 ? 1 : 0,
                crea: numeroCrea,
                tipo: tipoId.value,
                status: status.value,
                receita_inicial: receitaInicial,
                receitas_emitidas: receitasEmitidas,
                filial: filial.value,
                assinatura: assinaturaId.value,
                usuario: usuario === '' ? "" : usuario,
                senha: senha === '' ? "" : senha,
            }

            try {
                if (estadoId && numeroCrea && tipoId.value && status.value && filial) {

                    setErroAgronomo(false);
                    setErroEstado(false);
                    setErroNumeroCrea(false);
                    setErroTipo(false);
                    setErroFilial(false);
                    setErroUsuario(false);
                    setErroSenha(false);

                    if (estadoId === 'RJ') {
                        if (receitaInicial && receitaInicial != '' && receitaInicial != 0 && receitaInicial != '0') {

                            const response = await api.post(`/agronomos/${agronomoId}/creas`, payload);
                            if (props.isModal === true) {
                                props.update();
                            } else {
                                window.location = '/agronomos';
                            }
                            setLoading(false);

                            store.addNotification({
                                title: "Sucesso!",
                                message: `O ${tipoId.label} foi salvo`,
                                type: "success",
                                insert: "top",
                                container: "top-right",
                                animationIn: ["animated", "fadeIn"],
                                animationOut: ["animated", "fadeOut"],
                                dismiss: {
                                    duration: 4000,
                                    onScreen: true
                                }
                            })

                            if (isTotvs && localStorage.getItem("@TOTVS_crea") === "true") {
                                localStorage.removeItem("@TOTVS_crea");
                            }
                        } else {
                            if (!receitaInicial) {
                                setErroReceitaInicial(true);

                                store.addNotification({
                                    title: "Erro!",
                                    message: `Verifique os campos em vermelho`,
                                    type: "danger",
                                    insert: "top",
                                    container: "top-right",
                                    animationIn: ["animated", "fadeIn"],
                                    animationOut: ["animated", "fadeOut"],
                                    dismiss: {
                                        duration: 4000,
                                        onScreen: true
                                    }
                                });
                            } else {
                                setErroReceitaInicial(false);
                            }
                        }
                    } else {
                        const response = await api.post(`/agronomos/${agronomoId}/creas`, payload);

                        if (response) {
                            if (usuarioEs !== '' && senhaEs !== '') {
                                const responseUsersES = await api.post(`/agronomos/usuario/${agronomoId}/ES`, {
                                    usuario: usuarioEs,
                                    senha: senhaEs
                                });
                            }
                            if (usuarioSc != '' && senhaSc != '') {
                                const responseUsersSC = await api.post(`/agronomos/usuario/${agronomoId}/SC`, {
                                    usuario: usuarioSc,
                                    senha: senhaSc
                                });
                            }
                        }

                        setLoading(false);
                        if (props.isModal === true) {
                            props.update();
                        } else {
                            window.location = '/agronomos';
                        }

                        store.addNotification({
                            title: "Sucesso!",
                            message: `O ${tipoId.label} foi salvo`,
                            type: "success",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 4000,
                                onScreen: true
                            }
                        })

                        if (isTotvs && localStorage.getItem("@TOTVS_crea") === "true") {
                            localStorage.removeItem("@TOTVS_crea");
                        }

                    }
                } else {
                    setLoading(false);

                    if (!estadoId) {
                        setErroEstado(true);
                    } else {
                        setErroEstado(false);
                        if (estadoId === "RJ") {
                            if (!receitaInicial) {
                                setErroReceitaInicial(true);
                            } else {
                                const select = document.getElementById("receita_inicial");
                                select.classList.remove("error");
                                setErroReceitaInicial(false);
                            }
                        }
                    }

                    if (!numeroCrea) {
                        setErroNumeroCrea(true);
                    } else {
                        setErroNumeroCrea(false);
                    }

                    if (!tipoId.value) {
                        setErroTipo(true);
                    } else {
                        setErroTipo(false);
                    }

                    if (!filial) {
                        setErroFilial(true);
                    } else {
                        setErroFilial(false);
                    }

                    if (!usuario) {
                        setErroUsuario(true);
                    } else {
                        setErroUsuario(false);
                    }

                    if (!senha) {
                        setErroSenha(true);
                    } else {
                        setErroSenha(false);
                    }

                    store.addNotification({
                        title: "Erro!",
                        message: `Verifique os campos em vermelho`,
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 4000,
                            onScreen: true
                        }
                    });
                }
            } catch (error) {
                store.addNotification({
                    title: "Erro!",
                    message: identifyErrorMenssage(error),
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            }


        } else {
            setLoading(true);
            const payloadA = {
                nome,
                cpf,
                email,
                assinatura: electronicSignatureOverride || sign,
                email,
                enviar_receita,
                whatsapp
            };
            const payload = {
                estado: estadoId.value || estadoId,
                homologar_automatico: (
                    estadoId.value === 'MT' || estadoId.value === 'SC' || estadoId.value === 'ES' || estadoId.value === 'GO' || estadoId.value === 'DF' || estadoId === 'NACIONAL'
                ) && contractSoftId != 6 ? 1 : 0,
                crea: numeroCrea,
                tipo: tipoId.value,
                status: status.value,
                receita_inicial: receitaInicial,
                receitas_emitidas: receitasEmitidas,
                filial: filial.value,
                assinatura: assinaturaId.value,
                usuario: usuario === '' ? "" : usuario,
                senha: senha === '' ? "" : senha,
            }

            try {
                if (estadoId && numeroCrea && tipoId.value && status.value && filial) {
                    setErroEstado(false);
                    setErroNumeroCrea(false);
                    setErroTipo(false);
                    setErroFilial(false);

                    if (estadoId === 'RJ') {
                        if (receitaInicial && receitaInicial != '' && receitaInicial != 0 && receitaInicial != '0') {
                            const response = await api.post(`/agronomos`, payloadA);
                            let agronomo_id = response.data.data.id;

                            const responsee = await api.post(`/agronomos/${agronomo_id}/creas`, payload);
                            if (props.isModal === true) {
                                props.update();
                            } else {
                                props.loc.history.push('/agronomos');
                            }
                            setLoading(false);

                            if (isTotvs && localStorage.getItem("@TOTVS_crea") === "true") {
                                localStorage.removeItem("@TOTVS_crea");
                            }

                            return (<>
                                {store.addNotification({
                                    title: "Sucesso!",
                                    message: `O ${tipoId.label} foi salvo`,
                                    type: "success",
                                    insert: "top",
                                    container: "top-right",
                                    animationIn: ["animated", "fadeIn"],
                                    animationOut: ["animated", "fadeOut"],
                                    dismiss: {
                                        duration: 4000,
                                        onScreen: true
                                    }
                                })

                                }
                            </>)
                        } else {
                            if (!receitaInicial) {
                                setErroReceitaInicial(true);
                                store.addNotification({
                                    title: "Erro!",
                                    message: `Verifique os campos em vermelho`,
                                    type: "danger",
                                    insert: "top",
                                    container: "top-right",
                                    animationIn: ["animated", "fadeIn"],
                                    animationOut: ["animated", "fadeOut"],
                                    dismiss: {
                                        duration: 4000,
                                        onScreen: true
                                    }
                                });
                            } else {
                                setErroReceitaInicial(false);
                            }
                        }
                    } else {

                        const response = await api.post(`/agronomos`, payloadA);
                        let agronomo_id = response.data.data.id;

                        const responsee = await api.post(`/agronomos/${agronomo_id}/creas`, payload);

                        if (responsee) {
                            if (response) {
                                if (usuarioEs !== '' && senhaEs !== '') {
                                    const responseUsersES = await api.post(`/agronomos/usuario/${agronomo_id}/ES`, {
                                        usuario: usuarioEs,
                                        senha: senhaEs
                                    });
                                }
                                if (usuarioSc != '' && senhaSc != '') {
                                    const responseUsersSC = await api.post(`/agronomos/usuario/${agronomo_id}/SC`, {
                                        usuario: usuarioSc,
                                        senha: senhaSc
                                    });
                                }
                            }
                        }
                        setLoading(false);
                        if (props.isModal === true) {
                            props.update();
                        } else {
                            props.loc.history.push('/agronomos');
                        }

                        if (isTotvs && localStorage.getItem("@TOTVS_crea") === "true") {
                            localStorage.clear("@TOTVS_crea");
                        }
                        
                        return (<>
                            {store.addNotification({
                                title: "Sucesso!",
                                message: `O ${tipoId.label} foi salvo`,
                                type: "success",
                                insert: "top",
                                container: "top-right",
                                animationIn: ["animated", "fadeIn"],
                                animationOut: ["animated", "fadeOut"],
                                dismiss: {
                                    duration: 4000,
                                    onScreen: true
                                }
                            })

                            }
                        </>)
                    }
                } else {
                    setLoading(false);

                    if (!estadoId) {
                        setErroEstado(true);
                    } else {
                        setErroEstado(false);
                        if (estadoId === "RJ") {
                            if (!receitaInicial) {
                                setErroReceitaInicial(true);
                            } else {
                                const select = document.getElementById("receita_inicial");
                                select.classList.remove("error");
                                setErroReceitaInicial(false);
                            }
                        }
                    }

                    if (!numeroCrea) {
                        setErroNumeroCrea(true);
                    } else {
                        setErroNumeroCrea(false);
                    }
                    if (!tipoId.value) {
                        setErroTipo(true);
                    } else {
                        setErroTipo(false);
                    }

                    if (!filial) {
                        setErroFilial(true);
                    } else {
                        setErroFilial(false);
                    }

                    if (!usuario) {
                        setErroUsuario(true);
                    } else {
                        setErroUsuario(false);
                    }

                    if (!senha) {
                        setErroSenha(true);
                    } else {
                        setErroSenha(false);
                    }

                    store.addNotification({
                        title: "Erro!",
                        message: `Verifique os campos em vermelho`,
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 4000,
                            onScreen: true
                        }
                    });
                }
            } catch (err) {

                try {
                    if (err.response.data.errors[0].alerta) {
                        store.addNotification({
                            title: "Aviso!",
                            message: `${err.response.data.errors[0].alerta}`,
                            type: "warning",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 4000,
                                onScreen: true
                            }
                        });
                    } else {

                        if (err.response.data.errors) {
                            store.addNotification({
                                title: "Erro!",
                                message: `${err.response.data.errors}`,
                                type: "danger",
                                insert: "top",
                                container: "top-right",
                                animationIn: ["animated", "fadeIn"],
                                animationOut: ["animated", "fadeOut"],
                                dismiss: {
                                    duration: 4000,
                                    onScreen: true
                                }
                            });
                        } else {
                            store.addNotification({
                                title: "Erro!",
                                message: `Verifique os campos em vermelho`,
                                type: "danger",
                                insert: "top",
                                container: "top-right",
                                animationIn: ["animated", "fadeIn"],
                                animationOut: ["animated", "fadeOut"],
                                dismiss: {
                                    duration: 4000,
                                    onScreen: true
                                }
                            });
                        }

                    }
                } catch (error) {
                    if (err.response.data.errors) {
                        store.addNotification({
                            title: "Erro!",
                            message: identifyErrorMenssage(err),
                            type: "danger",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 4000,
                                onScreen: true
                            }
                        });

                    }

                }
            }
            setLoading(false);
        }
    }

    const saveElectronicSignature = async (dataUri) => {
        if (agronomoId) {
            try {
                const payload = {
                    nome: agronomoNome,
                    cpf,
                    email,
                    enviar_receita,
                    whatsapp,
                    assinatura: dataUri,
                };
                const response = await api.put(`/agronomos/${agronomoId}`, payload);
                if (response) {
                    setHasElectronicCredentialLocal(true);
                    setShowSignatureModal(false);
                    store.addNotification({
                        title: "Sucesso!",
                        message: `Assinatura salva com sucesso!`,
                        type: "success",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: { duration: 4000, onScreen: true }
                    });
                }
            } catch (error) {
                store.addNotification({
                    title: "Erro!",
                    message: identifyErrorMenssage(error),
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: { duration: 4000, onScreen: true }
                });
            }
        } else {
            setElectronicSignatureOverride(dataUri);
            setHasElectronicCredentialLocal(true);
            setShowSignatureModal(false);
        }
    }

    const modalUploadClose = (e) => {
        if (e) {
            setHasDigitalCredentialLocal(true);
        } else {
            setAssinaturaId({ value: 'M', label: 'Manual' });
        }
        setShowModalUpload(false);
    }

    const enviaSenha = (usuarios) => {
        if (usuarios['sc']) {
            setUsuarioSc(usuarios['sc'].usuario);
            setSenhaSc(usuarios['sc'].senha);
        }

        if (usuarios['es']) {
            setUsuarioEs(usuarios['es'].usuario);
            setSenhaEs(usuarios['es'].senha);
        }
    }

    const getTiposAssinatura = async (estado) => {
        try {
            setIsLoadingSignRules(true);
            setTiposAssinatura([]);
            const response = await api.get(`/sign/estado/${estado}`);

            const tipos = response.data.data;
            let tipo = []

            if (tipos.manual === true) {
                tipo = [...tipo, { value: 'M', label: 'Manual' }];
            }
            if (tipos.digital === true) {
                tipo = [...tipo, { value: 'D', label: 'Digital' }];
            }
            if (tipos.eletronica === true) {
                tipo = [...tipo, { value: 'E', label: 'Eletrônica' }];
            }

            setTiposAssinatura(tipo);

        } catch (error) {
        } finally {
            setIsLoadingSignRules(false);
        }
    }

    const changeEstado = (estado) => {
        if (estadoId === '') {
            setEstadoId(estado);

            if (estado.value === 'NACIONAL') {
                setTipoId({ value: 'cfta', label: 'CFTA' });
            }

            if (estado.value) {
                getTiposAssinatura(estado.value);
            }
        } else if (estadoId.value != estado.value) {
            setEstadoId(estado);

            if (estado.value === 'NACIONAL') {
                setTipoId({ value: 'cfta', label: 'CFTA' });
            }

            if (estado.value) {
                getTiposAssinatura(estado.value);
            }
        }
    }

    const changeTipoCrea = (tipo) => {

        if (tipo) {

            if (tipo.value != tipoId.value) {
                setTipoId(tipo);
                if (tipo.value === 'cfta') {
                    setEstadoId('NACIONAL');
                } else {
                    if (estadoId.value == 'NACIONAL') {
                        setEstadoId({ value: '', label: '' });
                    }
                }
            }
        } else {
            setTipoId('');
        }
    }

    const validaEstadoVisto = async () => {
        if (agronomo !== null) {
            if (agronomo.creas) {
                agronomo.creas.map(c => {
                    if (c.tipo == 'crea' && c.estado == estadoId && c.status == 1) {
                        store.addNotification({
                            title: "Erro!",
                            message: `O Responsável Técnico já possui CREA cadastrado nesse estado! `,
                            type: "danger",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 4000,
                                onScreen: true
                            }
                        })
                    } else if (c.tipo == 'visto' && c.estado == estadoId && c.status == 1) {
                        store.addNotification({
                            title: "Erro!",
                            message: `O Responsável Técnico já possui VISTO cadastrado para esse estado! `,
                            type: "danger",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 4000,
                                onScreen: true
                            }
                        })
                    }
                })
            }
        }

    };

    const goToPlans = () => {
        setShowModalBlockSign(false);
        props.propsLocation.history.push('/planos');
    }


    useEffect(() => {
        getFiliais();
        let user = JSON.parse(localStorage.getItem(USER));

        user.contrato.agro_plan_functions.map((e) => {
            if (e.agro_plans_function.id === 9) {
                if (e.status === 0) {
                    setBlockSign(true);
                }
            }
        });

        if (user.contrato.agro_plan_config.is_teste === 0) {
            setContractSoftId(8);
        } else {
            setContractSoftId(6);
        }

        setHomologAutomatico({ value: 0, label: 'Não' });

        if (agronomoId) {
            getAgronomos();
        } else {
            setAgronomoNome(props.nome)
        }


        if (props.estadoId) {
            changeEstado(props.estadoId);
        }

    }, []);

    useEffect(() => {
        if (tiposAssinatura.length > 0) {
            if (props.certificado == true) {
                selectAssinatura({ value: 'D', label: 'Digital' })
            } else {
                selectAssinatura({ value: 'M', label: 'Manual' })
            }
        }
    }, [tiposAssinatura]);

    useEffect(() => {
        if (!blockSign) {
            if (assinaturaId.value === 'D') {
                if (props.certificado == false) {
                    setShowModalUpload(true);
                }
            }
        }
    }, [assinaturaId]);

    useEffect(() => {
        if ((tipoId.value == 'crea') && isCrea == true) {

            store.addNotification({
                title: "Erro!",
                message: `O Responsável Técnico já possui CREA cadastrado! `,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            })
        } else {

            if (tipoId.value == 'visto') {
                validaEstadoVisto();
            } else if (tipoId.value == 'cfta') {
            }

        }
    }, [tipoId]);


    const getFilialsForSelect = async () => {
        try {
            const response = await api.get(`/filiais`);
            const filiais = response.data.data;

            if (filiais.length) {
                const formatFiliais = filiais.map(f => {
                    let format = {
                        value: f.id,
                        label: f.nome_fantasia
                    };
                    return format;
                });

                if (filiais && filiais.length > 0) {
                    setFiliais(formatFiliais);
                } else {
                    setFiliais(formatFiliais);
                }
            } else {
                const formatFiliais = [{ value: filiais.id, label: filiais.nome_fantasia }];
                setFiliais(formatFiliais);

            }
        } catch (e) {

        }
    }

    useEffect(() => {
        getFilialsForSelect()
    }, []);

    return (
        <>
            <FormContainer {...props}>
                <Container>

                    <form>

                        <Input
                            marginBottom="16px"
                            name="responsavelTecnico"
                            type="text"
                            label="Responsável Técnico"
                            labelWithAsterisk={true}
                            id="responsavel_tecnico"
                            value={agronomoNome}
                            erro={erroAgronomo}
                        />

                        <Select
                            marginBottom="46px" 
                            name="filial"
                            className="select"
                            label="Filial"
                            labelWithAsterisk={true}
                            id="filial_id"
                            disabled={false}
                            value={filial.value || filial}
                            onChange={e => setFilial(e)}
                            erro={erroFilial}
                            options={filiais}
                            selectUniqueOption={true}
                        />

                        <Select
                            marginBottom="46px"
                            name="tipo"
                            className="select"
                            label="CREA/VISTO/CFTA"
                            labelWithAsterisk={true}
                            id="tipo_id"
                            disabled={false}
                            value={tipoId.value || tipoId}
                            onChange={(tipo) => changeTipoCrea(tipo)}
                            erro={erroTipo}
                            options={tipos}
                            selectUniqueOption={true}
                        />


                        {tipoId.value == 'cfta' ? (
                            <Select
                                marginBottom="46px"
                                name="estado"
                                className="select"
                                label="Estado"
                                labelWithAsterisk={true}
                                id="estado_cfta_id"
                                disabled={true}
                                value={"NACIONAL"}
                                estado={true}
                                onChange={estado => (changeEstado(estado))}
                                options={estados}
                                selectUniqueOption={true}
                            />
                        ) : (
                            <Select
                                marginBottom="46px"
                                name="estado"
                                className="select"
                                label="Estado"
                                labelWithAsterisk={true}
                                id="estado_crea_id"
                                disabled={false}
                                value={estadoId.value != '' ? estadoId.value : ''}
                                estado={true}
                                onChange={estado => (changeEstado(estado))}
                                options={estados1}
                                erro={erroEstado}
                                selectUniqueOption={true}
                            />
                        )}


                        <Input
                            marginBottom="18px"
                            name="numeroCrea"
                            type="text"
                            label="Número - CREA/Visto/CFTA"
                            labelWithAsterisk={true}
                            id="crea_id"
                            onChange={e => validateNumeroCrea(e)}
                            value={numeroCrea}
                            erro={erroNumeroCrea}
                        />

                        {estadoId.value === "SC" || estadoId === "SC" ? (
                            <>
                                <Input
                                    marginBottom="10px"
                                    id='user'
                                    name="user"
                                    type="text"
                                    label="Usuário SIGEN"
                                    labelWithAsterisk={true}
                                    onChange={e => setUsuario(e)}
                                    value={usuario}
                                    erro={erroUsuario}
                                />

                                <div className="senha">
                                    <Input
                                        marginBottom="10px"
                                        id='pass'
                                        name="pass"
                                        type={typePassword}
                                        label="Senha SIGEN"
                                        labelWithAsterisk={true}
                                        onChange={e => setSenha(e)}
                                        value={senha}
                                        erro={erroSenha}
                                    />
                                </div>
                            </>
                        ) : (<>
                            {estadoId.value === "ES" || estadoId === "ES" && contractSoftId != 6 ? (
                                <>
                                    <Input
                                        marginBottom="10px"
                                        id='user'
                                        name="user"
                                        type="text"
                                        label="Usuário IDAF"
                                        labelWithAsterisk={true}
                                        onChange={e => setUsuario(e)}
                                        value={usuario}
                                        erro={erroUsuario}
                                    />

                                    <div className="senha">
                                        <Input
                                            marginBottom="10px"
                                            id='pass'
                                            name="pass"
                                            type={typePassword}
                                            label="Senha IDAF"
                                            labelWithAsterisk={true}
                                            onChange={e => setSenha(e)}
                                            value={senha}
                                            erro={erroSenha}
                                        />
                                    </div>
                                </>
                            ) : (
                                null
                            )}
                        </>)}

                        {isLoadingSignRules ? (
                            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginBottom: '25px' }}>
                                <S.Loading />
                            </div>
                        ) : (
                            <div style={{ width: '100%', marginBottom: '25px' }}>
                                <SignatureTypeCards
                                    value={assinaturaId.value || assinaturaId}
                                    onChange={(type) => selectAssinatura({ value: type, label: SIGN_LABELS[type] })}
                                    allowedSignatures={tiposAssinatura.map((t) => t.value)}
                                    estadoValue={estadoId.value || estadoId}
                                    hasDigitalCredential={hasDigitalCredentialLocal}
                                    hasElectronicCredential={hasElectronicCredentialLocal}
                                    namePrefix="card_radio_assinatura_crea"
                                    responsavelNome={nome}
                                    onUploadCertificado={() => setShowModalUpload(true)}
                                    onCadastrarAssinatura={() => setShowSignatureModal(true)}
                                />
                            </div>
                        )}


                        {estadoId === 'RJ' || estadoId.value === 'RJ' ? 
                         <div style={{width: '100%', height: 'auto', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <Input
                                marginTop="25px"
                                marginBottom="0px"
                                name="receitaInicial"
                                type="text"
                                label="Receita Inicial"
                                id="receita_inicial"
                                value={receitaInicial}
                                onChange={e => validateReceitaInicial(e)}
                                onBlur={e => validateReceitaZero(e.target.value)}
                            />

                            <Tooltip
                                content={<div style={{ textAlign: 'left', padding: '10px', maxWidth: '280px' }}>
                                    Ex: Se você já emitiu 20 receitas com esta ART, coloque aqui 21.
                                </div>}
                                animation="fade"
                                delay={[300, 100]}
                                arrow={true}
                                placement="right"
                            >
                                <img src={iconQuestionBlue} alt="Ajuda" style={{ width: '20px', height: '20px', marginLeft: '8px', cursor: 'pointer' }} />
                            </Tooltip>
                        </div> : null}


                        <div className="button-finish" style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: '15px', marginBottom: '0px' }}>
                            <Button
                                width='100%'
                                height='50px'
                                value='CADASTRAR'
                                outline={false}
                                disabled={isLoadingSignRules}
                                onClick={() => handlePost()}
                                loading={loading}
                            />
                        </div>

                    </form>

                    <ModalUpload
                        show={showModalUpload}
                        onHide={(e) => modalUploadClose(e)}
                        cpf={props.cpf}
                    />

                    <ModalGeneric
                        show={showSignatureModal}
                        size='md'
                        onHide={() => setShowSignatureModal(false)}
                    >
                        <ModalBody>
                            <ModalTitle>Cadastrar assinatura eletrônica</ModalTitle>
                            <InputSign
                                sign={electronicSignatureOverride || sign || ''}
                                update={(dataUri) => saveElectronicSignature(dataUri)}
                            />
                        </ModalBody>
                    </ModalGeneric>

                    <S.Container>
                        <ModalGeneric
                            show={showModalBlockSign}
                            size='lg'
                            onHide={() => {
                                setShowModalBlockSign(false);
                                setAssinaturaId({ value: 'M', label: 'Manual' })
                            }}
                        >
                            <ModalBody>
                                <S.ContainerContent>
                                    <img src={ModalImage} alt='Imagem celular com campos de texto e botão' />

                                    <H5 color={theme.colors.gray.Cinza_5}>Este recurso não está <br/> disponível no seu plano</H5>

                                    <BodyG color={theme.colors.gray.Cinza_5}>
                                        Para desbloquear essa e outras funcionalidades,<br/> faça seu upgrade agora mesmo.
                                    </BodyG>

                                    <S.ButtonPlans>
                                        <ButtonV2
                                            width='90%'
                                            height='60px'
                                            value='Ver Planos'
                                            outline={false}
                                            disabled={false}
                                            onClick={() => window.location = '/planos'}
                                            loading={false}
                                        ></ButtonV2>
                                    </S.ButtonPlans>
                                </S.ContainerContent>

                            </ModalBody>
                        </ModalGeneric>
                    </S.Container>
                </Container>
            </FormContainer>
        </>
    );
};

export default AddCreas;
